import React from 'react';
import styled from 'styled-components';
import { colors } from '~/styles';
import { EmptyState } from './shared';
import TurnBlock from './TurnBlock';

const Timeline = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  font-size: 0.875rem;

  > *:not(:last-child) {
    padding-bottom: 1rem;
    border-bottom: solid 1px ${colors.grey20};
    margin-bottom: 1rem;
  }
`;

export default function TraceTimeline({ turns, pricing }) {
  if (!turns || turns.length === 0) return <EmptyState>No trace events recorded for this conversation.</EmptyState>;

  return (
    <Timeline>
      {turns.map((turn) => (
        <TurnBlock key={turn.traceId} turn={turn} pricing={pricing} />
      ))}
    </Timeline>
  );
}
